import AccountGroupArrayField from './AccountGroupArrayField';

export default AccountGroupArrayField;
